import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query FacebookPermissions($customerId: ID!) {
    facebookPermissions(customerId: $customerId)
  }
`;

export const queryFacebookPermissions = (customerId) => {
  return executeGqlQuery({
    query: QUERY,
    variables: { customerId },
  })
    .then(({ data }) => getSingleProp(data))
    .then((result) => result);
};
